import {
  diagLogLevelFromString,
  getNumberFromEnv,
  getStringFromEnv,
} from '@opentelemetry/core'
import { defaultServiceName } from '@opentelemetry/resources'
import { stringToBoolean } from './utils/misc'

const env = process.env

export const DEFAULT_EXPORTER_BATCH_SIZE =
  getNumberFromEnv('OTEL_BLRP_MAX_EXPORT_BATCH_SIZE') ?? 512
export const DEFAULT_EXPORTER_TIMEOUT_MS =
  getNumberFromEnv('OTEL_BLRP_EXPORT_TIMEOUT') ?? 30000
export const DEFAULT_MAX_QUEUE_SIZE =
  getNumberFromEnv('OTEL_BLRP_MAX_QUEUE_SIZE') ?? 2048
export const DEFAULT_OTEL_TRACES_EXPORTER = getStringFromEnv(
  'OTEL_TRACES_EXPORTER'
)
export const DEFAULT_OTEL_TRACES_EXPORTER_URL =
  getStringFromEnv('OTEL_EXPORTER_OTLP_TRACES_ENDPOINT') ??
  (getStringFromEnv('OTEL_EXPORTER_OTLP_ENDPOINT')
    ? `${getStringFromEnv('OTEL_EXPORTER_OTLP_ENDPOINT')}/v1/traces`
    : 'https://mxl-otelcol.apps.ocpthikadev01.safaricom.net/v1/traces')
export const DEFAULT_OTEL_TRACES_SAMPLER =
  getStringFromEnv('OTEL_TRACES_SAMPLER') ?? 'parentbased_always_on'
export const DEFAULT_OTEL_TRACES_SAMPLER_ARG =
  getStringFromEnv('OTEL_TRACES_SAMPLER_ARG') ?? '1'
export const DEFAULT_OTEL_EXPORTER_OTLP_TRACES_TIMEOUT =
  getNumberFromEnv('OTEL_EXPORTER_OTLP_TRACES_TIMEOUT') ?? 60000
export const DEFAULT_SEND_INTERVAL_MS =
  getNumberFromEnv('OTEL_BLRP_SCHEDULE_DELAY') ?? 2000
export const DEFAULT_OTEL_LOGS_EXPORTER = getStringFromEnv('OTEL_LOGS_EXPORTER')
export const DEFAULT_OTEL_LOGS_EXPORTER_URL =
  getStringFromEnv('OTEL_EXPORTER_OTLP_LOGS_ENDPOINT') ??
  (getStringFromEnv('OTEL_EXPORTER_OTLP_ENDPOINT')
    ? `${getStringFromEnv('OTEL_EXPORTER_OTLP_ENDPOINT')}/v1/logs`
    : 'https://mxl-otelcol.apps.ocpthikadev01.safaricom.net/v1/logs')
export const DEFAULT_OTEL_METRICS_EXPORTER = env.OTEL_METRICS_EXPORTER // not exist yet
export const DEFAULT_OTEL_METRICS_EXPORTER_URL =
  getStringFromEnv('OTEL_EXPORTER_OTLP_METRICS_ENDPOINT') ??
  (getStringFromEnv('OTEL_EXPORTER_OTLP_ENDPOINT')
    ? `${getStringFromEnv('OTEL_EXPORTER_OTLP_ENDPOINT')}/v1/metrics`
    : 'https://mxl-otelcol.apps.ocpthikadev01.safaricom.net/v1/metrics')
export const DEFAULT_OTEL_METRIC_EXPORT_INTERVAL =
  env.OTEL_METRIC_EXPORT_INTERVAL
    ? Number(env.OTEL_METRIC_EXPORT_INTERVAL)
    : 60000 // not exist yet
export const DEFAULT_OTEL_METRIC_EXPORT_TIMEOUT = env.OTEL_METRIC_EXPORT_TIMEOUT
  ? Number(env.OTEL_METRIC_EXPORT_TIMEOUT)
  : 30000 // not exist yet
export const DEFAULT_SERVICE_NAME = () =>
  getStringFromEnv('OTEL_SERVICE_NAME') ?? defaultServiceName()
export const DEFAULT_OTEL_LOG_LEVEL = diagLogLevelFromString('OTEL_LOG_LEVEL')

// MXL SDK specific configuration
export const DEFAULT_MXL_API_KEY = () => env.MXL_API_KEY
export const DEFAULT_MXL_STARTUP_LOGS =
  stringToBoolean(env.MXL_STARTUP_LOGS) ?? true
export const DEFAULT_MXL_NODE_BETA_MODE = () =>
  stringToBoolean(env.MXL_NODE_BETA_MODE) ?? false
export const DEFAULT_MXL_NODE_CONSOLE_CAPTURE =
  stringToBoolean(env.MXL_NODE_CONSOLE_CAPTURE) ?? true
export const DEFAULT_MXL_NODE_ADVANCED_NETWORK_CAPTURE =
  stringToBoolean(env.MXL_NODE_ADVANCED_NETWORK_CAPTURE) ?? false
export const DEFAULT_MXL_NODE_STOP_ON_TERMINATION_SIGNALS =
  stringToBoolean(env.MXL_NODE_STOP_ON_TERMINATION_SIGNALS) ?? true
export const DEFAULT_MXL_NODE_EXPERIMENTAL_EXCEPTION_CAPTURE =
  stringToBoolean(env.MXL_NODE_EXPERIMENTAL_EXCEPTION_CAPTURE) ?? false
export const DEFAULT_MXL_NODE_ENABLE_INTERNAL_PROFILING =
  stringToBoolean(env.MXL_NODE_ENABLE_INTERNAL_PROFILING) ?? false
